import type { PatientType } from "./types";
import { useI18n } from "./i18n";

export function PatientTypeStep(props: { onSelect: (type: PatientType) => void }) {
  const t = useI18n();

  return (
    <div class="flex flex-col gap-5">
      <h2 class="text-xl font-bold text-typography-primary">{t("schedule_appointment")}</h2>

      <p class="text-sm font-medium text-typography-secondary">{t("new_or_existing")}</p>

      <div class="flex flex-col gap-3">
        <button
          type="button"
          class="group flex items-center gap-4 rounded-2xl border border-brand-subtle p-5 text-left transition-all hover:border-brand-primary hover:bg-brand-light hover:shadow-sm active:scale-[0.98]"
          onClick={() => props.onSelect("new_patient")}
        >
          <div>
            <p class="font-semibold text-typography-primary">{t("new_patient")}</p>
            <p class="text-sm text-typography-secondary">{t("first_time_visiting")}</p>
          </div>
        </button>

        <button
          type="button"
          class="group flex items-center gap-4 rounded-2xl border border-brand-subtle p-5 text-left transition-all hover:border-brand-primary hover:bg-brand-light hover:shadow-sm active:scale-[0.98]"
          onClick={() => props.onSelect("existing_patient")}
        >
          <div>
            <p class="font-semibold text-typography-primary">{t("existing_patient")}</p>
            <p class="text-sm text-typography-secondary">{t("been_here_before")}</p>
          </div>
        </button>
      </div>
    </div>
  );
}
